// Price formatter for the Tamoré storefront.
// All current products are priced in INR. Falls back gracefully.
const SYMBOLS = { INR: "₹", USD: "$", EUR: "€", GBP: "£" };

export function formatPrice(amount, currency = "INR") {
  const code = String(currency).toUpperCase();
  const symbol = SYMBOLS[code] || "";
  const value = Number(amount || 0);
  const formatted = code === "INR"
    ? value.toLocaleString("en-IN", { maximumFractionDigits: 0 })
    : value.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return symbol ? `${symbol}${formatted}` : `${formatted} ${code}`;
}
